import { enqueueSnackbar, closeSnackbar, VariantType, SnackbarKey } from 'notistack';

export const notify = (
  message: string,
  variant: VariantType = 'default',
  options: Record<string, any> = {}
) => {
  enqueueSnackbar(message, {
    variant,
    ...options,
  });
};

export const showBanner = (
  message: string,
  variant: VariantType = 'default',
  options: Record<string, any> = {}
) => {
  enqueueSnackbar(message, {
    variant,
    autoHideDuration: 6000,
    anchorOrigin: { vertical: 'top', horizontal: 'right' },
    ...options,
  });
};

export const dismiss = (key?: SnackbarKey) => {
  closeSnackbar(key);
};

export {};